import Commodities from '../components/Commodities/index';
const CommoditiesPage = () => {
    return (
        <><Commodities/></>
    )
}

export default CommoditiesPage